import React from "react";
import DashboardInstance from "./DashboardInstance/DashboardInstance";

export default props => <DashboardInstance {...props} />;
